export function updateTitle(title: string | null | undefined): void {
  if (typeof document === "undefined" || !title) return;
  document.title = title;
}

export function updateFavicon(faviconUrl: string | null | undefined): void {
  if (typeof document === "undefined" || !faviconUrl) return;

  const selector = "link[rel='icon'], link[rel='shortcut icon']";
  const existing = document.head.querySelector<HTMLLinkElement>(selector);
  const link = existing ?? document.createElement("link");

  link.rel = "icon";
  link.href = faviconUrl;

  if (!existing) {
    document.head.appendChild(link);
  }
}
